import React from 'react'
import { Control, Controller, ControllerRenderProps } from 'react-hook-form'
import { Switch, SwitchProps } from './Switch'

type Props = SwitchProps & {
  control: Control
  name: string
}

export function ControlledSwitch(props: Props): React.ReactElement {
  const { control, name, defaultChecked, ...switchProps } = props

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultChecked ?? false}
      render={({
        value,
        onChange,
      }: Omit<ControllerRenderProps, 'value'> & { value: boolean }) => (
        <Switch
          {...switchProps}
          name={name}
          checked={value}
          onChange={(event, newValue) => onChange(newValue)}
        />
      )}
    />
  )
}
